import { render } from "./SmSheetProperties.vue?vue&type=template&id=10be4d75&scoped=true"
import script from "./SmSheetProperties.vue?vue&type=script&lang=js"
export * from "./SmSheetProperties.vue?vue&type=script&lang=js"

import "./SmSheetProperties.vue?vue&type=style&index=0&id=10be4d75&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10be4d75"]])

export default __exports__